export const API_SUCCESS = 'API_SUCCESS';
export const MODELSLOADING = "MODELSLOADING";
export const MODELSLOADED = "MODELSLOADED";

export const SEARCHING = "SEARCHING";
export const SEARCHED = "SEARCHED";
export const CLAIMSPAGENUMBERLOADED = "CLAIMSPAGENUMBERLOADED";